'use strict';

const $ = require('jquery');

/**
 * Add smooth scroll to certain links inside container.
 * @param elContainer
 * @param options
 * @constructor
 */
const SmoothScroll = function(elContainer = document.documentElement, options = {}) {
    const _ = this;

    /**
	 * Init
	 * @param options
	 */
    var init = function(options) {
        _.container = elContainer;
        _._defaultSettings = {
            smoothScrollLinks: '[data-smooth-scroll]',
            offset: 0,
            scrollDuration: 2000,
            medias: new Array(),
        };
        _._customSettings = options;
        _._$htmlBody = $('html, body');

        _._constructPrivates();

        _._resetHashScroll();

        _.addEventListenerToLinks();

        let elError = document.querySelector('.widget.error');

        // Scroll to anchor if hash in URL
        if (window.location.hash) {
            setTimeout(function() {
                _.scrollTo(document.querySelector(window.location.hash));
            }, 500);
        } else if (elError) {
            setTimeout(function() {
                _.scrollTo(elError);
            }, 2000);
        }
    };

    _._constructPrivates = function() {
        _.settings = _.mapOptions(_._defaultSettings, _._customSettings);
        _._mapMediaOptions();
    };

    _._createSmoothScrollEvent = function() {
        return new CustomEvent('smoothscroll', {
            detail: {
                SmoothScroll: _,
            },
            cancelable: true,
        });
    };

    /**
	 * Scroll to specific element
	 * @param el
	 * @param intOffset
	 * @param intDuration
	 */
    _.scrollTo = function(el, intOffset = _.settings.offset, intDuration = _.settings.scrollDuration) {
        _.scrollToElement = el;
        let scrollEvent = _.container.dispatchEvent(_._createSmoothScrollEvent());

        if (el && scrollEvent) {
            document.documentElement.classList.add('is-scrolling');

            _._$htmlBody.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() {
                _.stop();
            });

            _._$htmlBody.animate({
                scrollTop: $(el).offset().top - intOffset,
            }, {
                duration: intDuration,
                queue: true,
                complete: _._onAnimationComplete,
            });
        }
    };

    _._onAnimationComplete = function() {
        _.stop();
    };

    _.stop = function() {
        _._$htmlBody.clearQueue();
        _._$htmlBody.stop();
        _._$htmlBody.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');

        document.documentElement.classList.remove('is-scrolling');
    };

    _._mapMediaOptions = function() {
        _.settings = _.mapOptions(_._defaultSettings, _._customSettings);

        if (_.settings.medias) {
            _.settings.medias.forEach(function(item) {
                if (window.matchMedia(item.media).matches) {
                    _.settings = _.mapOptions(_.settings, item.settings);
                }
            });
        }
    };

    /**
	 * Add event listeners to links
	 * @param nl
	 */
    _.addEventListenerToLinks = function() {
        $(_.settings.smoothScrollLinks).each(function() {
            if ($(this.hash).length > 0) {
                $(this).on('click', function(e) {
                    _.scrollTo(document.querySelector(this.hash));

                    e.preventDefault();
                });
            }
        });
    };

    /**
	 * Reset scroll if hash is set in location
	 * @private
	 */
    _._resetHashScroll = function() {
        // Force instant scroll to top in case URL contains hash
        if (window.location.hash) {
            scroll(0, 0);
        }

        setTimeout(function() {
            scroll(0, 0);
        }, 1);
    };

    _._resizeListener = function() {
        clearTimeout(_._resizeTimeout);

        _._resizeTimeout = setTimeout(function() {
            _._mapMediaOptions();
            _._constructPrivates();
        }, 100);
    };

    _.mapOptions = function(objSettings, options) {
        let settings = Object.assign({}, objSettings);
        if (Array.isArray(objSettings)) {
            settings = objSettings.map((x) => x);
        } else {
            settings = Object.assign({}, objSettings);
        }

        Object.keys(options).forEach((strKey) => {
            if (typeof options[strKey] === 'object') {
                settings[strKey] = _.mapOptions(settings[strKey], options[strKey]);
            } else {
                settings[strKey] = options[strKey];
            }
        });

        return settings;
    };

    init(options);
};

export default SmoothScroll;
